/**
 * Corso Player - JavaScript Controller
 * Handles lesson navigation, video playback, and progress tracking
 */

(function() {
  'use strict';

  function initCorsoPlayer() {
    // DOM Elements
    const videoPlayer = document.getElementById('corso-video-player');
    const lessonList = document.getElementById('corso-lesson-list');
    const lessonTitle = document.getElementById('corso-lesson-title');
    const lessonDescription = document.getElementById('corso-lesson-description');
    const downloadBtn = document.getElementById('corso-download-btn');
    const progressFill = document.getElementById('corso-progress-fill');
    const nextBtn = document.getElementById('corso-next-btn');
    const videoContainer = document.querySelector('.corso-video-container');
    
    // Check if elements exist
    if (!videoPlayer || !lessonList) {
      console.warn('Corso Player: elementi non trovati');
      return;
    }

    // Data
    const corsoDataEl = document.getElementById('corso-data');
    if (!corsoDataEl) {
      console.warn('Corso Player: dati non trovati');
      return;
    }
    
    const corsoData = JSON.parse(corsoDataEl.textContent);
    const { lessons, totalLessons, storageKey } = corsoData;
    
    // State
    let currentLessonIndex = 0;
    let progress = loadProgress();
    let hls = null;

    /**
 * Convert Shopify Rich Text to HTML
 */
function richTextToHtml(richText) {
  if (!richText) return '';
  if (typeof richText === 'string') {
    try {
      richText = JSON.parse(richText);
    } catch (e) {
      return richText;
    }
  }
  
  function renderNode(node) {
    if (!node) return '';
    
    if (node.type === 'text') {
      let text = node.value || '';
      if (node.bold) text = `<strong>${text}</strong>`;
      if (node.italic) text = `<em>${text}</em>`;
      return text;
    }
    
    const children = (node.children || []).map(renderNode).join('');
    
    switch (node.type) {
      case 'root':
        return children;
      case 'paragraph':
        return `<p>${children}</p>`;
      case 'heading':
        const level = node.level || 2;
        return `<h${level}>${children}</h${level}>`;
      case 'link':
        return `<a href="${node.url || '#'}" target="_blank" rel="noopener">${children}</a>`;
      case 'list':
        const tag = node.listType === 'ordered' ? 'ol' : 'ul';
        return `<${tag}>${children}</${tag}>`;
      case 'list-item':
        return `<li>${children}</li>`;
      default:
        return children;
    }
  }
  
  return renderNode(richText);
}

    console.log('Corso Player inizializzato con', totalLessons, 'lezioni');

    /**
     * Show loading state
     */
    function showLoading() {
      if (videoContainer) {
        videoContainer.classList.add('is-loading');
      }
    }

    /**
     * Hide loading state
     */
    function hideLoading() {
      if (videoContainer) {
        videoContainer.classList.remove('is-loading');
      }
    }

    /**
     * Check if lesson has a valid video URL
     */
    function hasVideo(lesson) {
      return lesson.videoUrl && 
             lesson.videoUrl !== '' && 
             lesson.videoUrl !== 'null' && 
             lesson.videoUrl !== null;
    }

    function isHls(url) {
  return /\.m3u8(\?|$)/i.test(url);
}

function destroyHls() {
  if (hls) {
    hls.destroy();
    hls = null;
  }
}

function setVideoSource(url) {
  destroyHls();
  videoPlayer.removeAttribute('src');

  if (isHls(url)) {
    if (window.Hls && Hls.isSupported()) {
      hls = new Hls({ maxBufferLength: 30 });
      hls.loadSource(url);
      hls.attachMedia(videoPlayer);

      hls.on(Hls.Events.ERROR, function(event, data) {
        if (!data.fatal) return;
        console.warn('HLS errore fatale:', data.type, data.details);
        switch (data.type) {
          case Hls.ErrorTypes.NETWORK_ERROR:
            hls.startLoad();
            break;
          case Hls.ErrorTypes.MEDIA_ERROR:
            hls.recoverMediaError();
            break;
          default:
            destroyHls();
            hideLoading();
        }
      });
      return;
    }

    if (videoPlayer.canPlayType('application/vnd.apple.mpegurl')) {
      // Safari / iOS: HLS nativo
      videoPlayer.src = url;
      videoPlayer.load();
      return;
    }

    console.warn('HLS non supportato su questo browser');
    hideLoading();
    return;
  }

  // MP4 o altro formato progressivo
  videoPlayer.src = url;
  videoPlayer.load();
}

    /**
     * Load a specific lesson
     */
    function loadLesson(index) {
      if (index < 0 || index >= totalLessons) return;
      
      const lesson = lessons[index];
      if (!lesson) return;
      
      currentLessonIndex = index;
      console.log('Caricamento lezione:', index, lesson.title);
      
      // Check if lesson has video
      if (hasVideo(lesson)) {
        // Show loading state
        showLoading();
        
        // Update video
        setVideoSource(lesson.videoUrl);
        
        // Show video container
        if (videoContainer) {
          videoContainer.style.display = 'block';
        }
      } else {
        // No video - hide player
        videoPlayer.pause();
        destroyHls();
        videoPlayer.removeAttribute('src');
        videoPlayer.load();
        hideLoading();
        
        // Hide video container
        if (videoContainer) {
          videoContainer.style.display = 'none';
        }
        
        console.log('Lezione senza video:', lesson.title);
      }
      
      // Update lesson info
      if (lessonTitle) {
        lessonTitle.textContent = lesson.title;
      }
      
      if (lessonDescription) {
        lessonDescription.innerHTML = richTextToHtml(lesson.description);
      }
      
      // Update download button
      if (downloadBtn) {
        if (lesson.resourceUrl && lesson.resourceUrl !== '') {
          downloadBtn.href = lesson.resourceUrl;
          downloadBtn.style.display = 'inline-flex';
        } else {
          downloadBtn.style.display = 'none';
        }
      }
      
      // Update sidebar active state
      const items = lessonList.querySelectorAll('.corso-lesson-item');
      items.forEach((item, i) => {
        item.classList.toggle('is-active', i === index);
      });
      
      // Scroll active item into view
      const activeItem = lessonList.querySelector('.corso-lesson-item.is-active');
      if (activeItem) {
        activeItem.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
      }
      
      // Update next button state
      if (nextBtn) {
        nextBtn.disabled = index >= totalLessons - 1;
        nextBtn.innerHTML = index >= totalLessons - 1 
          ? 'Corso completato!' 
          : 'Prossima Lezione <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><polyline points="9 18 15 12 9 6"></polyline></svg>';
      }
      
      // Save progress
      progress.lastViewed = index;
      saveProgress();
      
      // Update overall progress bar
      updateOverallProgress();
    }

    /**
     * Handle video canplay event
     */
    function onVideoCanPlay() {
      hideLoading();
    }

    /**
     * Handle video waiting event (buffering)
     */
    function onVideoWaiting() {
      showLoading();
    }

    /**
     * Handle video playing event
     */
    function onVideoPlaying() {
      hideLoading();
    }

    /**
     * Handle video ended event
     */
    function onVideoEnded() {
      markLessonCompleted(currentLessonIndex);
      
      // Don't auto-advance, just mark as completed
      // User can click "Prossima Lezione" manually
    }

    /**
     * Handle video time update
     */
    function onTimeUpdate() {
      if (videoPlayer.duration) {
        const watchedPercent = (videoPlayer.currentTime / videoPlayer.duration) * 100;
        if (watchedPercent >= 90) {
          markLessonCompleted(currentLessonIndex);
        }
      }
    }

    /**
     * Mark a lesson as completed
     */
    function markLessonCompleted(index) {
      if (!progress.completed) {
        progress.completed = [];
      }
      
      if (!progress.completed.includes(index)) {
        progress.completed.push(index);
        saveProgress();
        updateProgressUI();
      }
    }

    /**
     * Update progress UI elements
     */
    function updateProgressUI() {
      const items = lessonList.querySelectorAll('.corso-lesson-item');
      
      items.forEach((item, index) => {
        const checkMark = item.querySelector('.corso-lesson-check');
        const isCompleted = progress.completed && progress.completed.includes(index);
        
        item.classList.toggle('is-completed', isCompleted);
        if (checkMark) {
          checkMark.dataset.completed = isCompleted;
        }
      });
      
      updateOverallProgress();
    }

    /**
     * Update overall progress bar
     */
    function updateOverallProgress() {
      if (!progressFill) return;
      const completedCount = progress.completed ? progress.completed.length : 0;
      const percent = (completedCount / totalLessons) * 100;
      progressFill.style.width = percent + '%';
    }

    /**
     * Load progress from localStorage
     */
    function loadProgress() {
      try {
        const saved = localStorage.getItem(storageKey);
        return saved ? JSON.parse(saved) : { completed: [], lastViewed: 0 };
      } catch (e) {
        return { completed: [], lastViewed: 0 };
      }
    }

    /**
     * Save progress to localStorage
     */
    function saveProgress() {
      try {
        localStorage.setItem(storageKey, JSON.stringify(progress));
      } catch (e) {
        console.warn('Unable to save progress to localStorage');
      }
    }

    // === EVENT BINDINGS ===

    // Lesson item clicks
    lessonList.addEventListener('click', function(e) {
      const lessonItem = e.target.closest('.corso-lesson-item');
      if (lessonItem) {
        const index = parseInt(lessonItem.dataset.lessonIndex, 10);
        loadLesson(index);
      }
    });
    
    // Next button
    if (nextBtn) {
      nextBtn.addEventListener('click', function() {
        if (currentLessonIndex < totalLessons - 1) {
          loadLesson(currentLessonIndex + 1);
        }
      });
    }
    
    // Video events
    videoPlayer.addEventListener('ended', onVideoEnded);
    videoPlayer.addEventListener('timeupdate', onTimeUpdate);
    videoPlayer.addEventListener('canplay', onVideoCanPlay);
    videoPlayer.addEventListener('waiting', onVideoWaiting);
    videoPlayer.addEventListener('playing', onVideoPlaying);
    videoPlayer.addEventListener('loadstart', showLoading);
    
    // Keyboard navigation
    document.addEventListener('keydown', function(e) {
      if (e.target.tagName === 'INPUT' || e.target.tagName === 'TEXTAREA') return;
      
      switch(e.key) {
        case 'ArrowRight':
          if (e.shiftKey && currentLessonIndex < totalLessons - 1) {
            loadLesson(currentLessonIndex + 1);
          }
          break;
        case 'ArrowLeft':
          if (e.shiftKey && currentLessonIndex > 0) {
            loadLesson(currentLessonIndex - 1);
          }
          break;
        case ' ':
          if (document.activeElement === document.body) {
            e.preventDefault();
            videoPlayer.paused ? videoPlayer.play() : videoPlayer.pause();
          }
          break;
      }
    });

    // === INITIALIZATION ===

    // Restore last viewed lesson or load first lesson
    const lastViewed = progress.lastViewed || 0;
    if (lastViewed > 0 && lastViewed < totalLessons) {
    loadLesson(lastViewed);
    } else {
    // Load first lesson to ensure UI is synced
    loadLesson(0);
    }
    
    // Update UI with saved progress
    updateProgressUI();

    // Expose reset function globally
    window.resetCorsoProgress = function() {
      progress = { completed: [], lastViewed: 0 };
      saveProgress();
      updateProgressUI();
      loadLesson(0);
      console.log('Progress reset');
    };
  }

  // Initialize when DOM is fully ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initCorsoPlayer);
  } else {
    setTimeout(initCorsoPlayer, 0);
  }

})();